export default {
  reset_password_title: "Reset Password",
  reset_pass_desc:
    "Please enter your email address and we will send you a link to reset your password.",
  reset_pass: "Reset Password",
  reset_pass_requested: "Password reset request received",
  reset_pass_check_email:
    "Please check your email and follow the instructions to reset your password.",
  reset_pass_email_sent_info:
    "If that email exists in our system, a password reset link has been sent.",
  reset_pass_did_not_receive: "Didn't receive the email? Please check your spam folder.",
  reset_pass_resend_email: "Resend Password Reset Email",
  reset_pass_resend_available_in: "Resend available in {seconds} seconds",
  reset_pass_resending: "Resending...",
  reset_pass_resent_success: "Password reset email resent successfully",
  reset_pass_please_wait: "Please wait {seconds} seconds before resending",
  reset_pass_request_failed: "Password reset request failed",
  email_required: "Please enter your email address",
  email_invalid: "Please enter a valid email address",
  email_placeholder: "your{0}example.com",
  daily_limit_reached: "Daily resend limit reached. Please try again tomorrow.",
  remaining_attempts: "{count} attempts remaining today",
};
